import React, { useEffect, useRef, useState } from "react";
import { useLocation, Route, Switch, Redirect } from "react-router-dom";

import AdminNavbar from "components/Navbars/AdminNavbar";
import Footer from "components/Footer/Footer";
import Sidebar from "components/Sidebar/Sidebar";
import routes from "routes.js";
import { useAuth } from "AuthProvider";

import sidebarImage from "assets/img/passLogo.png";

function Admin() {
  const [image, setImage] = React.useState(sidebarImage);
  const [color, setColor] = React.useState("blue");
  const [hasImage, setHasImage] = React.useState(true);
  const [isSmallScreen, setIsSmallScreen] = React.useState(false); // State to track if it's a small screen
  const location = useLocation();
  const mainPanel = useRef(null);
  const { role } = useAuth();

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout !== "/pass") return null;

      // Block admin-only routes at the router level.
      // When role is null auth is still resolving — render nothing so admins
      // aren't incorrectly bounced to /dashboard before their role is known.
      // Once role resolves to a non-admin value, redirect immediately.
      if (prop.adminOnly) {
        if (role === null) {
          return <Route key={key} path={prop.layout + prop.path} render={() => null} />;
        }
        if (role !== 'admin') {
          return (
            <Route
              key={key}
              path={prop.layout + prop.path}
              render={() => <Redirect to="/pass/dashboard" />}
            />
          );
        }
      }

      return (
        <Route
          path={prop.layout + prop.path}
          render={(props) => <prop.component {...props} />}
          key={key}
        />
      );
    });
  };

  const handleResize = () => {
    const screenWidth = window.innerWidth;
    const newIsSmallScreen = screenWidth < 993;

    if (isSmallScreen !== newIsSmallScreen) {
      window.location.reload(); // Refresh the page when crossing the breakpoint
    }
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    // Initial setup
    setIsSmallScreen(window.innerWidth < 993);
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainPanel.current.scrollTop = 0;

    // Close the sidebar if it's open on small screens
    if (isSmallScreen && document.documentElement.className.indexOf("nav-open") !== -1) {
      document.documentElement.classList.toggle("nav-open");
      var element = document.getElementById("bodyClick");
      element && element.parentNode.removeChild(element);
    }

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isSmallScreen, location]);

  return (
    <>
      <div className="wrapper" >
        {isSmallScreen ? null : (
          <Sidebar color={color} image={hasImage ? image : ""} routes={routes} />
        )}
        <div className="main-panel" ref={mainPanel}>
          {/* <AdminNavbar /> */}
          <div className="content">
            <Switch>{getRoutes(routes)}</Switch>
          </div>
          {/* <Footer /> */}
        </div>
      </div>
    </>
  );
}

export default Admin;
